"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "OverflowDivider", {
    enumerable: true,
    get: function() {
        return OverflowDivider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _useOverflowDivider = require("../../useOverflowDivider");
const OverflowDivider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { groupId, children } = props;
    const containerRef = (0, _useOverflowDivider.useOverflowDivider)(groupId);
    return (0, _reactutilities.applyTriggerPropsToChildren)(children, {
        ref: (0, _reactutilities.useMergedRefs)(containerRef, ref)
    });
});
